import { BenefitNavigationExtensionInterface } from '../../../../extension/interface/benefit-navigation.extension.interface';
import { BenefitMenuItemInterface } from '../../nav/BenefitMenuItem';

export class NewsBenefitNavigationExtension extends BenefitNavigationExtensionInterface {
  getMenuItems(): BenefitMenuItemInterface[] {
    return [
      {
        title: 'subPage.news',
        to: `/benefits/news`,
      },
    ];
  }
}
